module.exports = __webpack_public_path__ + "img/green-gem-2.8e7b3f30.png";